import { LinkWithImage } from "../../models";
import { CHALLENGES } from "./hardcodedContentfulContent";

export const fetchAllChallenges = async (): Promise<LinkWithImage[]> => {
  // Used to fetched from Contentful, now hard coded.
  return CHALLENGES.data.challengeCollection.items;
};
